import { render, staticRenderFns } from "./BaseAdmin.vue?vue&type=template&id=02151d84&scoped=true"
import script from "./BaseAdmin.vue?vue&type=script&lang=js"
export * from "./BaseAdmin.vue?vue&type=script&lang=js"
import style0 from "./BaseAdmin.vue?vue&type=style&index=0&id=02151d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02151d84",
  null
  
)

export default component.exports